/**
 * @desc It has all the json calls to get data for hotels,Invoked from searchresult.js 
 */

!function(name, module, context){
	//>>excludeStart("requireTmpl", pragmas.requireTmpl);
	if(window.define) define('hotels/fetchHotelsJson',["hotelBackgroundSearch"], module)
	else
	//>>excludeEnd("requireTmpl");
		context[name] = module(CT.hotelBackgroundSearch)
}('fetchHotelsJson', function(hotelBackgroundSearch){
	
	var _hotelContent, _scData , _airBnbContent,_opaqueHotelId = [];
	var fetchHotelsJson = {

			empty: function(){
				_scData = null;
				_hotelContent = null;
				_airBnbContent = null;
				_opaqueHotelId = [];
			},
			setHotelContent : function(data,callBackFuncParams){
				var paramsHash = CT.cache[CT.settings.currentTab].searchParams.all;
				_hotelContent = data;
				//fetchHotelsJson.fetchStaticCityContent();
				//For Chunky Filters fire create chunky filters with updated settings
				if(window.chunkyFiltersEnabled){
					var copyHFD = JSON.parse(JSON.stringify(data.hfd));
					copyHFD.push({expanded: false,name: "Locality",rank: 7});
					CT.fire('createChunkyFilters',[copyHFD]);
				}
				if(CT.settings[CT.app].airBnbCallStatus.airBnbCall == true && CT.subProd != "airBnb"){
					if(_scData && _airBnbContent){
						for(var k in _airBnbContent.ht){
							_hotelContent.ht.push(_airBnbContent.ht[k])
						}
						CT.fire('instasearch.dynamicLoadReady', [_hotelContent, _scData, callBackFuncParams, _airBnbContent]);
						fetchHotelsJson.empty();
					}else{
						CT.fire('instasearch.hotelContentReady', [_hotelContent , callBackFuncParams , _airBnbContent]);
					}
				}else{
					if(window.enableOpaque){
						for(var k in _hotelContent.ht){
							if(_hotelContent.ht[k].op){
								_opaqueHotelId.push(_hotelContent.ht[k].id);
							}
						}
						if(_opaqueHotelId.length > 0){
							CT.cache[CT.settings.currentTab].opaqueHotelsArr = _opaqueHotelId;
							callBackFuncParams.opaqueHotelId = _opaqueHotelId
						}
					}
					if(_scData){
						CT.fire('instasearch.dynamicLoadReady', [_hotelContent, _scData, callBackFuncParams]);
						fetchHotelsJson.empty();
					}else{
						CT.fire('instasearch.hotelContentReady', [_hotelContent , callBackFuncParams]);
					}
				}
				
			},
			
			logParams : function(data){
				
				$.ajax({
					url: '/source/abtest/getabtestconfig',
					type: 'POST',
					data:"data="+data
				})
			},
			
			
			setScData : function(data , callBackFuncParams){
				_scData = data;
				// CT.isLocationEnabled = data.lse;
				// Enabling location serach 
				if ((window.productDomain === 'QADOMCOMDOMIN' || window.productDomain === 'PRODDOMCOMDOMAIN' ) && window.enableLocalityFilter ){
					CT.isLocationEnabled = window.enableLocalityFilter;
				} else {
					CT.isLocationEnabled = data.lse;
				}
				if(CT.settings[CT.app].airBnbCallStatus.airBnbCall == true && CT.subProd != "airBnb"){
					if(_hotelContent && _airBnbContent){
						for(var k in _airBnbContent.ht){
							_hotelContent.ht.push(_airBnbContent.ht[k])
						}
						CT.fire('instasearch.dynamicLoadReady', [_hotelContent, _scData , callBackFuncParams , _airBnbContent]);
						fetchHotelsJson.empty();
					}
				}else{
					if(window.enableOpaque && _hotelContent){
						for(var k in _hotelContent.ht){
							if(_hotelContent.ht[k].op && _opaqueHotelId.length==0){
								_opaqueHotelId.push(_hotelContent.ht[k].id);
							}
						}
						if(_opaqueHotelId.length > 0){
							CT.cache[CT.settings.currentTab].opaqueHotelsArr = _opaqueHotelId;
							callBackFuncParams.opaqueHotelId = _opaqueHotelId
						}
					}
					if(window.showTags){
						CT.tagsData = data.tags ? data.tags : undefined;
						if(CT.tagsData == undefined){
							//window.showTags = false;
							console.warn("place fetchHotelsJson");
						}else{
							var tagsDataLen =  CT.tagsData.length;
							CT.tagsPriorityHash =  _.reduce(CT.tagsData,function(prev,curr,idx){
			                    prev[curr.tagId] = Math.pow((tagsDataLen - idx),2);
			                    return prev;
			                },{})
						}
					}
					if(_hotelContent){
						CT.fire('instasearch.dynamicLoadReady', [_hotelContent, _scData , callBackFuncParams]);
						fetchHotelsJson.empty();
					}
				}
				var sid = data.sid;
				
				CT.logParamsForAb += ";SID="+sid
				// fetchHotelsJson.logParams(CT.logParamsForAb)
				
			},
			
					
			fetchAjaxData : function(options){
				var jqXHR = $.ajax({
						url : options.url,
						data :  options.paramsData,
						type: "GET",
						beforeSend: function( xhr ) {
						
							if(window.isResultsPage)
								CT.cache[CT.settings.currentTab].eventsTimes[options.url.split('/').slice(-1)[0]] = [{s: new Date().getTime()}]; 
							if(options.reqHeaderSrc != undefined){
								xhr.setRequestHeader( "X-CT-SOURCETYPE", options.reqHeaderSrc );
							}
							if(options.reqHeaderTracking != undefined){
								xhr.setRequestHeader("X-CT-DOCUMENT_REFERER", options.reqHeaderTracking);
							}
						}
				}).done(function(data){
					if(window.isResultsPage) {
						CT.cache[CT.settings.currentTab].eventsTimes[options.url.split('/').slice(-1)[0]][0].e = new Date().getTime(); 
						if(options.url.match(/hotel-content/))
							CT.cache[CT.settings.currentTab].eventsTimes[options.url.split('/').slice(-1)[0]][0].r = ((typeof data == 'string') ? JSON.parse(data) : data).ht.length;
					}
					options.callBackFunc((typeof data == 'string') ? JSON.parse(data) : data , options.callBackFuncParams);
				}).fail(function(error){
					if(options.airBnb != true){
						CT.fire('search.disambError', [error]);
					}
				})
			},
			fetchAirBnbContent : function(){
				var paramsHash = CT.cache[CT.settings.currentTab].searchParams.all;
				var options = {} , paramsData = {} , callBackFuncParams = {};
				paramsData.city = CT.subProd != "wg"?paramsHash.city : paramsHash.from;
            	paramsData.state = paramsHash.state;
            	paramsData.country = paramsHash.country;
            	paramsData.results = CT.settings[CT.app].airBnbCallStatus.resultsType;
            	//paramsData.startIdx = CT.settings[CT.app].airBnbCallStatus.startIdx;
            	//paramsData.endIdx = CT.settings[CT.app].airBnbCallStatus.endIdx;
				
            	options.url = CT.settings[CT.app]["airBnb"].urls.hotelContent;
            	callBackFuncParams.airBnb = true;
            	options.airBnb = true;
            	options.paramsData = _.serialize(paramsData);
            	options.callBackFunc = fetchHotelsJson.airBnbContentSucc;
            	options.callBackFuncParams = callBackFuncParams
            	fetchHotelsJson.fetchAjaxData(options)
			},
			airBnbContentSucc : function(data,callBackFuncParams){
				var options = {};
				options.airBnbData = true;
				_airBnbContent = data;
				if(_hotelContent){
					CT.masterJson.update(data)
					CT.masterJson.updateGroupedHotels(data.ht);
				}else{
					CT.masterJson.set(data)
					CT.masterJson.setGroupedHotels(data.ht);
				}
				
				//CT.masterJson.set(data)
				//CT.masterJson.setGroupedHotels(data.ht);
				if(_hotelContent && _airBnbContent && _scData){
					CT.fire('instasearch.dynamicLoadReady', [_hotelContent, _scData , callBackFuncParams , _airBnbContent]);
				//	CT.fire('instasearch.dynamicLoadReady', [_airBnbContent, _scData , callBackFuncParams, _airBnbContent ]);
					fetchHotelsJson.empty();
				}
				//fetchHotelsJson.fetchScData(options);
			},
			fetchHotelContent : function(){
				var paramsHash = CT.cache[CT.settings.currentTab].searchParams.all;
				var options = {} , paramsData = {} , callBackFuncParams = {},bgObj = {};
				if(paramsHash.ct_hotelid != undefined && paramsHash.ct_hotelid != ""){
					bgObj = {ct_hotelid:paramsHash.ct_hotelid}
					paramsData.ct_hotelid = paramsHash.ct_hotelid;
				}else{
					paramsData.city = CT.subProd != "wg"?paramsHash.city : paramsHash.from;
	            	paramsData.state = paramsHash.state
	            	paramsData.country = paramsHash.country;
	            	bgObj = {city:paramsData.city,state:paramsData.state,country:paramsData.country};
	            }
				callBackFuncParams.isDateLess = CT.cache[CT.settings.currentTab].searchParams.processed.dateLessSearch;
				if(CT.subProd == "airBnb"){
					callBackFuncParams.airBnb = true;
				}
				if(CT.settings[CT.app].airBnbCallStatus.airBnbCall == true){
					callBackFuncParams.airBnb = true;
				}
				options.url =CT.subProd != "wg"?CT.subProd != "airBnb"?CT.settings.hotel.urls.hotelContent:CT.settings[CT.app][CT.subProd].urls.hotelContent:CT.settings[CT.app][CT.subProd].urls.hotelContent;
				paramsData.sct = window.countryCode.toUpperCase();
				
				if(window.enableOpaque && CT.subProd != "wg" && window.countryCode=='in' && window.product!="B2B"){
					options.url += "&op="+true	
				}
				
				options.paramsData = _.serialize(paramsData);
				options.callBackFunc = fetchHotelsJson.setHotelContent;
				options.callBackFuncParams = callBackFuncParams
				//If hotel content is already available then do not make api call again
				if(hotelBackgroundSearch.get("content")){
					options.callBackFunc(hotelBackgroundSearch.get("content"), options.callBackFuncParams);
				} else if($("#Tags")[0] && $("#Tags")[0].hotelContentBgSearch && CT.subProd != "wg"){
					var hotelContentBgSearch = $("#Tags")[0].hotelContentBgSearch;
					hotelContentBgSearch.get(bgObj, null, function(response){
						if(response && response.data){
							options.callBackFunc(response.data, options.callBackFuncParams)
						}else{
							//data not found.
							var error = (response && response.status)?response:{status:500};
							if(options.airBnb != true){
								CT.fire('search.disambError', [error]);
							}
						}
					});
				}else{
					fetchHotelsJson.fetchAjaxData(options);
				 }
														
			},	
			fetchStaticCityContent : function(){
				var paramsHash = CT.cache[CT.settings.currentTab].searchParams.all;
				var options = {} , paramsData = {} , callBackFuncParams = {};
				paramsData.city = CT.subProd != "wg"?paramsHash.city : paramsHash.from;
            	paramsData.state = paramsHash.state;
            	paramsData.country = paramsHash.country;
            	options.url = "http://dev.cleartrip.com/hotelstatic/json/staticCityContent.json";
            	options.paramsData = _.serialize(paramsData);
            	options.callBackFunc = fetchHotelsJson.staticCityContentSucc;
            	fetchHotelsJson.fetchAjaxData(options)
			},
			staticCityContentSucc : function(data){
				var hotelContent = CT.masterJson.get();
				for(var k in hotelContent.ht){
					var obj = data[hotelContent.ht[k].id];
					if(obj != undefined){
						hotelContent.ht[k].usp = obj[0].usp;
						hotelContent.ht[k].wai = obj[0].wai;
					}else{
						hotelContent.ht[k].usp = "";
						hotelContent.ht[k].wai = [];
					}
					
				}
				
			},
			fetchScData : function(_options){
				var paramsHash = CT.cache[CT.settings.currentTab].searchParams.all;
				var options = {} , callBackFuncParams = {};
				if(CT.subProd == "wg"){
					paramsHash.city=paramsHash.from;
				}
				if(CT.settings[CT.app].airBnbCallStatus.airBnbCall == true){
					paramsHash.abnb = true;
					callBackFuncParams.airBnb = true;
				}
				options.url = CT.subProd != "wg"?CT.subProd != "airBnb"?CT.settings.hotel.urls.scData:CT.settings[CT.app][CT.subProd].urls.scData:CT.settings[CT.app][CT.subProd].urls.scData;
				if( (window.productCode == "CP" && CT.app == "hotel") || (window.productCode == "AG" && CT.app == "hotel")){
					options.paramsData = _.serialize(paramsHash)+'&companyId='+window.companyId
					options.reqHeaderSrc = (window.productCode == "CP" ? "CORP" : "AGENCY");
				}else{
					if(paramsHash.country.toLowerCase() == "in" && window.hotelModalV2 == true && CT.subProd != "wg"){
						paramsHash.lowRate = true;
					}
					if(window.enableOpaque && CT.subProd != "wg"&& window.countryCode=='in' && window.product!="B2B"){
						paramsHash.op = true	
					}
					//Adding the Following check for PAH with CC guarantee
					if(window.countryCode=="in" && paramsHash.country.toLowerCase()=="in" && window.product!="B2B"){
						paramsHash.pahCCRequired=true;
					}
					paramsHash["all-hotels"] = true;
					options.paramsData = _.serialize(paramsHash);
					options.reqHeaderSrc = window.isMobileUA && window.isMobileUA == true ? "MOBILE" : undefined 
					options.reqHeaderTracking = document.referrer == "" ? "http://www.cleartrip.com/hotels" : document.referrer;
				}
				options.callBackFuncParams = callBackFuncParams;
				options.callBackFunc = fetchHotelsJson.setScData;
				//If hotel scData is already available then do not make api call again
				if(hotelBackgroundSearch.get("scData")){
					options.callBackFunc(hotelBackgroundSearch.get("scData"), options.callBackFuncParams);
				}else {
					fetchHotelsJson.fetchAjaxData(options)
				} 
			}
			
		};
	return {
		fetchHotelContent : fetchHotelsJson.fetchHotelContent,
		fetchScData : fetchHotelsJson.fetchScData,
		fetchAirBnbContent: fetchHotelsJson.fetchAirBnbContent
	}
}, this)
;
